import { dequal } from "dequal";

export const isDeepEqual = (obj1: any, obj2: any): boolean => {
  return dequal(obj1, obj2);
};
